import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Grid,
} from "@mui/material";
import ItemCard from "../Card/ItemCard";
import MockData from "../../mock/MOCK_DATA.json";
import PagePagination from "../Pagination/Pagination";
import { getProjectList } from "../../store/redux/projectSlice";
import LoadingScreen from "../LoadingScreen";
import InfiniteScroll from "react-infinite-scroll-component";


const ItemList = () => {
  const {data :item} = useSelector((state) => state.projects.projectList);
  // const [item, setItem] = useState([]);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(3); // Number of products per page
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true)


  useEffect(() => {
    // setItem(MockData);
    dispatch(getProjectList())
    setLoading(false);
  }, []);

  // Calculate pagination
  const indexOfLastItem = page * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =item ? item.slice(indexOfFirstItem, indexOfLastItem) : null;
  const totalPages = item ? Math.ceil(item.length / itemsPerPage) : null;

  const handleChangePage = (value) => {
    setPage(value);
    // item(item.concat(totalPages.item))
  };
  const showMoreltems = () => {
    setItemsPerPage((prevValue) => prevValue + 3);
  }
  return (
    
    <Container
    style={{ position: "absolute", top: 290, left: 131 }}
    maxWidth="lg"
  >
    {loading && <LoadingScreen />}
    {currentItems && item?.length > 0 ? (<><Grid container spacing={5}>
      {item.slice(0, itemsPerPage).map((product, i) =>{
        return <ItemCard key={i} data={product} />;
      })}
    </Grid>
    
        <div className="load">
          {currentItems < item && (
            <p className="btn-more" onClick={showMoreltems}><span class="down"></span>Load More</p>
          )}
           {currentItems >= item && (
            <p className="material-logo">Material +</p>
          )}
        </div>
      </>) : <LoadingScreen />}
    
  </Container>
  );
};

export default ItemList;
